import { deepMerge } from "./../../_shared/deep-merge.js";
import { TextStyleTransformer } from "../text-style-transformer.js";
import { createCustomStyles } from "./generators/custom-styles.js";
import {
  createColorPalette,
  createPalette,
  createThemeColorVars,
  createThemeColorVarsFromLegacyPalette,
  mapColorPaletteToCustomStyles
} from "./generators/palette.js";
import { createTypography } from "./generators/typography.js";
import { buildCssVarsObj } from "./theme-utils.js";
const buildThemeCssVars = (theme, documentStyle) => {
  const documentStyleTheme = TextStyleTransformer.fromDocumentStyle(documentStyle).toTheme();
  const mergedTheme = deepMerge({}, theme, documentStyleTheme);
  const { palette, colorPalette, paletteConfig, typography, customStyles, nativeStyle } = mergedTheme;
  const paletteResult = colorPalette ? createColorPalette(colorPalette, paletteConfig) : createPalette(palette, paletteConfig);
  const { paletteVarsObject } = paletteResult;
  const typographyVarsObject = createTypography(typography);
  const paletteCustomStyles = colorPalette ? mapColorPaletteToCustomStyles(colorPalette) : {};
  const mergedCustomStyles = deepMerge({}, paletteCustomStyles, customStyles);
  const customsVarsObject = createCustomStyles({
    customStyles: mergedCustomStyles,
    nativeStyle
  });
  const breakoutVars = {
    "breakout-normal-padding-start": theme?.breakout?.normalPadding.start ?? "0",
    "breakout-normal-padding-end": theme?.breakout?.normalPadding.end ?? "0",
    "breakout-full-width-padding-start": theme?.breakout?.fullWidthPadding?.start ?? "0",
    "breakout-full-width-padding-end": theme?.breakout?.fullWidthPadding?.end ?? "0"
  };
  const themeColorVars = colorPalette ? createThemeColorVars(colorPalette) : paletteResult.colors ? createThemeColorVarsFromLegacyPalette(paletteResult.colors) : {};
  const varsObj = {
    ...paletteVarsObject,
    ...themeColorVars,
    ...typographyVarsObject,
    ...customsVarsObject,
    ...breakoutVars
  };
  return buildCssVarsObj(varsObj);
};
const buildThemePortalCssVars = (theme) => {
  const { palette, colorPalette, paletteConfig, settingsStyles, customStyles = {} } = theme;
  const portalPaletteResult = colorPalette ? createColorPalette(colorPalette, {
    settingsActionColor: paletteConfig?.settingsActionColor
  }) : createPalette(palette, {
    settingsActionColor: paletteConfig?.settingsActionColor
  });
  const customsVarsObject = createCustomStyles({
    customStyles: { staticToolbar: customStyles?.staticToolbar },
    settingsStyles
  });
  const themeColorVars = colorPalette ? createThemeColorVars(colorPalette) : portalPaletteResult.colors ? createThemeColorVarsFromLegacyPalette(portalPaletteResult.colors) : {};
  return buildCssVarsObj({
    settingsActionColor: portalPaletteResult.paletteVarsObject.settingsActionColor,
    settingsActionColorTuple: portalPaletteResult.paletteVarsObject.settingsActionColorTuple,
    ...themeColorVars,
    ...customsVarsObject
  });
};
export {
  buildThemeCssVars,
  buildThemePortalCssVars
};
//# sourceMappingURL=build-theme-css-vars.js.map
